import { Textarea as CTextarea, TextareaProps } from '@chakra-ui/react';
import * as React from 'react';

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (props, ref) => (
    <CTextarea
      _hover={{ borderColor: 'primary.500' }}
      backgroundColor="transparent"
      borderColor={
        props.value || props.defaultValue ? 'primary.500' : 'primary.400'
      }
      errorBorderColor="error.500"
      focusBorderColor="secondary.500"
      ref={ref}
      resize="none"
      rounded="md"
      sx={{
        '&[aria-invalid=true], &[data-invalid], &:focus': {
          boxShadow: 'none',
        },
        '&[aria-invalid=true]:focus, &[aria-invalid=true]:focus:hover': {
          borderColor: 'error.700',
        },
        '&[aria-invalid=true]:hover': {
          borderColor: 'error.600',
        },
      }}
      {...props}
    />
  ),
);

export default Textarea;
